import React from "react";
import { TenantSwitcher } from "../dev/tenant-switcher";

const LoadingPage: React.FC = () => {
  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  const isDebug = process.env.NODE_ENV === "development";

  return (
    <div
      style={{
        position: "absolute",
        zIndex: 1000,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "#E8B13F",
        color: "white",
        fontFamily: "system-ui, -apple-system, sans-serif",
        padding: "20px",
      }}
    >
      {/* Debug Tenant Switcher - only show on localhost in debug mode */}
      {isLocalhost && isDebug && (
        <div
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            zIndex: 1000,
          }}
        >
          <TenantSwitcher />
        </div>
      )}

      {/* Loading Spinner Container */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Circular Progress Spinner */}
        <div
          style={{
            position: "relative",
            width: "120px",
            height: "120px",
            marginBottom: "30px",
          }}
        >
          {/* Outer rotating circle */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "120px",
              height: "120px",
              border: "4px solid rgba(255, 255, 255, 0.3)",
              borderTop: "4px solid white",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
            }}
          />

          {/* Inner square logo container */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "80px",
              height: "80px",
              borderRadius: "8px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {/* Tournoi-co square logo */}
            <img
              src="/assets/logo.png"
              alt="Tournoi-co Logo"
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </div>
        </div>

        {/* Loading text */}
        <h1
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            marginBottom: "10px",
            color: "white",
            textAlign: "center",
          }}
        >
          Loading Tournament
        </h1>

        <p
          style={{
            fontSize: "1rem",
            opacity: 0.9,
            textAlign: "center",
            maxWidth: "400px",
            lineHeight: 1.5,
          }}
        >
          Preparing your tournament experience...
        </p>

        {/* Debug information for developers */}
        {isLocalhost && isDebug && (
          <div
            style={{
              marginTop: "40px",
              background: "rgba(0, 0, 0, 0.2)",
              borderRadius: "10px",
              padding: "20px",
              fontSize: "0.8rem",
              opacity: 0.8,
              textAlign: "left",
              maxWidth: "500px",
            }}
          >
            <h4 style={{ marginBottom: "10px", fontSize: "0.9rem" }}>
              🛠️ Developer Info
            </h4>
            <p style={{ margin: "5px 0" }}>
              <strong>Current hostname:</strong> {window.location.hostname}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Environment:</strong> {process.env.NODE_ENV}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Tenant ID:</strong>{" "}
              {localStorage.getItem("tenant") || "none"}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Config ID:</strong>{" "}
              {localStorage.getItem("configId") || "none"}
            </p>
            <p style={{ margin: "5px 0", fontSize: "0.75rem", opacity: 0.7 }}>
              Use the tenant switcher in the top-right corner to select a
              tournament configuration.
            </p>
          </div>
        )}
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoadingPage;
